import React from "react";

export const Help = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Help & Support</h2>
      <p className="text-gray-600">Documentation and support resources</p>
    </div>
  );
};
